/**
 * 门户请求
 */
import axios from '../axios';
// const baseURL='/rz_gdygsm/common';
const baseURL='/common';
// 获取诚信字典表
export const getDicList = function() {
    return axios({
        method: 'get',
        url: '/credit/dicList',
        baseURL: baseURL,
    })
};
// 政策法规
export const getPolicesAndRegulationList = function(param = {}) {
  return axios({
    method: 'post',
    baseURL: baseURL,
    url: '/policyRelease/list',
    data: { ...param },
  })
}
// 黑名单
export const getBlackListList = function(param = {}) {
  // console.log(param, 'request')
  return axios({
    method: 'post',
    baseURL: baseURL,
    url: '/blacklist/corpPersonList',
    data: { ...param },
  })
}
export const getBlackListByCorpCode = function(corpCode) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/blacklist/corpInfo/${corpCode}`,
  })
};
export const getBlackListInfoByCorpCode = function(corpCode) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/tbCorpBasicInfo/getCorpInfoByCorpCode?corpCode=${corpCode}`,
  })
};
export const getCompanyType = function() {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: '/tbCorpBasicInfo/getTbEconTypeDicList',
  })
};
export const getPersonBlackListByIdCard = function(idCard) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/blacklist/personInfo/${idCard}`,
  })
};
export const getIdCardInfoByCorpCode = function(idCard) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/blacklist/getPersonInfoByIdCard?idCard=${idCard}`,
  })
};
export const getInfo = function(param) {
  return axios({
    method: 'post',
    baseURL: baseURL,
    url: `/policyRelease/info`,
    data: { ...param }
  })
};

// 诚信信息
export const getCreditInfoList = function(param = {}) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/tbCorpBasicInfo/getCreditInfoList?creditStatus=${param.creditStatus}&corpName=${param.corpName}&affirmDepartment=${param.affirmDepartment}&page=${param.page}&pageSize=${param.pageSize}`,
  })
}
// 信用评分
export const getCreditGradeList = function(param = {}) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/tbCorpBasicInfo/getCreditGradeList?dicBazaarId=${param.dicBazaarId}&corpName=${param.corpName}&lowScore=${param.lowScore}&highScore=${param.highScore}&page=${param.page}&pageSize=${param.pageSize}`,
  })
}
//诚信信息详情
export const getCreditGradeInfo = function(param = {}) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `tbCorpBasicInfo/getCreditGradeInfo?dicBazaarId=${param.dicBazaarId}&corpCode=${param.corpCode}`,
  })
}
//信用评分详情
export const getCorpCreditByUuid = function(param = {}) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `tbCorpBasicInfo/getCorpBasicInfo?uuid=${param.uuid}`,
  })
}
// 首页轮播
export const getCarousel = function() {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/carouselImage/home`,
  })
}
// 门户诚信信息列表
export const getWebPortalCreditInfo = function(param = {}) {
  return axios({
    method: 'get',
    baseURL: baseURL,
    url: `/tbCorpBasicInfo/getWebPortalCreditInfo?page=1&pageSize=8`,
  })
}
// 个人诚信列表
export const personalIntegritys = function(param) {
  return axios({
    method: 'post',
    baseURL: baseURL,
    url: `/personProtalHome/personalIntegritys`,
    data: { ...param }
  })
}
